// source: pbtypes/gen/flight_deck/task_kind.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.flight_deck.TaskKind', null, global);
goog.exportSymbol('proto.flight_deck.TaskKind.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.flight_deck.TaskKind = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.flight_deck.TaskKind, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.flight_deck.TaskKind.displayName = 'proto.flight_deck.TaskKind';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.flight_deck.TaskKind.prototype.toObject = function(opt_includeInstance) {
  return proto.flight_deck.TaskKind.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.flight_deck.TaskKind} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.TaskKind.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.flight_deck.TaskKind}
 */
proto.flight_deck.TaskKind.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.flight_deck.TaskKind;
  return proto.flight_deck.TaskKind.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.flight_deck.TaskKind} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.flight_deck.TaskKind}
 */
proto.flight_deck.TaskKind.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.flight_deck.TaskKind.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.flight_deck.TaskKind.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.flight_deck.TaskKind} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.flight_deck.TaskKind.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.flight_deck.TaskKind.Enum = {
  UNKNOWN: 0,
  INTERNAL: 1,
  ALIGNED_AUDIO: 5,
  LOG_CLEANER: 10,
  FLIGHT_LOGS_INGEST: 11,
  MEDIA_INGEST: 12,
  DELETE_MEDIA: 14,
  DELETE_FLIGHT: 18,
  SKILLS_EXPORT_DATA: 20,
  STITCH_PHOTOS: 21,
  CUSTOM_SKILL_TASK: 22,
  SURFACE_SCAN_PROCESS: 24,
  COVERAGE_SUMMARY: 25,
  SUMMARY_JSON: 26,
  FAKE_TASK_WITH_TIMEOUT: 27,
  SURFACE_SCAN_DISCARD_SCANS: 28,
  PHOTOGRAMMETRY_TASK: 29,
  MISSION_NCPG_TASK: 30,
  STITCH_PANORAMA: 31,
  TAR_POSE_GRAPH: 32,
  RTK_ATTACHMENT_PROCESS: 33,
  FLIGHT_FILE_MANIFEST: 34,
  MEDIA_CLEANER_TASK: 35,
  UCON_RESET_EXCLUDE_PATHS_TASK: 36
};

goog.object.extend(exports, proto.flight_deck);
